// URL de la API leída desde la variable de entorno
export const API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

// URL del logo (Si aún necesitas esto, podría venir de una variable de entorno o estar codificado)
// export const LOGO_URL = appConfig.LOGO_URL;
// Ejemplo si lo pones en .env como REACT_APP_LOGO_URL:
// export const LOGO_URL = process.env.REACT_APP_LOGO_URL || 'URL_POR_DEFECTO_SI_FALLA';
// O simplemente codificarlo si es estático:
export const LOGO_URL =
  "https://vod.streaminghd.cl/img/logo/LOGO-STREAMINGHD-v2.svg";

// Lista de salas disponibles
export const SALAS = [
  { id: 1, nombre: "Sala 1" },
  { id: 2, nombre: "Sala 2" },
  { id: 3, nombre: "Sala 3" },
  { id: 4, nombre: "Sala 4" },
  { id: 5, nombre: "Sala 5" },
  { id: 6, nombre: "Sala 6" },
  { id: 7, nombre: "Sala 7" },
];

// Lista de horas disponibles
export const HORAS = [
  "9AM",
  "10AM",
  "11AM",
  "12PM",
  "13PM",
  "14PM",
  "15PM",
  "16PM",
  "17PM",
  "18PM",
  "19PM",
  "20PM",
  "21PM",
];

// Colores de la aplicación
export const COLORS = {
  bgDark: "#16181C", // Fondo oscuro
  bgLight: "#21242a", // Fondo de contenedores
  primary: "#ff2b76", // Color primario (rosado)
  text: "#FFFFFF", // Color de texto
  error: "#ff3333", // Color de error
  success: "#33cc66", // Color de éxito
  warning: "#ffcc00", // Color de advertencia
};
